const JO = {
  ibanLength: 30,
};
export { JO };
